import React, { useEffect, useState } from "react";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import {
  incartUsers,
  toggleButtongoUsers,
  UsersCart,
} from "../../Components/Apis/apis";
import SideBar from "../../Components/Navbar/Sidebar";
import Switch from "react-switch";
import Head from "../../Components/ontabletop/head";
import { useLocation } from "react-router-dom";

const Incart = () => {
  const locations = useLocation();
  const path = locations.pathname;
  const [users, setUsers] = useState([]);
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState("");
  const [show, setShow] = useState(false[0]);
  const [query, setQuery] = useState("");
  const [postPerpage, setPostPerPage] = useState(10);

  const getUsers = async () => {
    const data = await incartUsers(path);
    if (data.message == "You are not authorized for this page") {
      alert(data.message);
    } else {
      setUsers(data);
      setTotal(data.length);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);
  const toggle = (index) => {
    if (show === index) {
      return setShow(null);
    }
    setShow(index);
  };

  const getData = async (userid) => {
    const data = await UsersCart(userid, path);
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      setPosts(data);
    }
  };

  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = users.slice(indexOfFirstPage, indexOfLastPage);

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">
          <h4>In Cart</h4>
        </div>
        <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
        <div>
          {/* making User tabel */}
          <table className="table table-boarder table-hover table-striped table-sm">
            <thead className="thead-darK">
              <tr>
                <th scope="col ">S.NO</th>
                <th scope="col">Client Name</th>
                <th scope="col">Email</th>
                <th scope="col">Contact NO</th>

                <th scope="col">In Cart </th>
              </tr>
            </thead>
            <tbody>
              {/* putting data on table by map function */}
              {currentPosts
                .filter((obj) => {
                  if (query == "") {
                    return obj;
                  } else if (
                    obj.name.toLowerCase().includes(query.toLowerCase()) ||
                    obj.code.toLowerCase().includes(query.toLowerCase())
                  ) {
                    return obj;
                  }
                })
                .map((obj, index) => (
                  <>
                    <tr key={obj.id}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        {obj.firstname}
                        {obj.lastname}
                      </td>
                      <td>{obj.email ? obj.email : "**N/A**"}</td>

                      <td>{obj.phonenumber || "**N/A**"}</td>

                      <td className="text-center">
                        <button
                          onClick={() => {
                            getData(obj.userid);
                            toggle(index);
                          }}
                          className="button is-small is-info  show-btn"
                        >
                          Show
                        </button>
                      </td>
                    </tr>
                    
                    <tr className="modalView">
                      {show === index ? (
                        <td colSpan={7}>
                          {posts.length > 0 ? (
                            <>
                              <div>
                                <div className="dataModal">
                                  <table className="table table-boarder table-hover table-striped  table-sm">
                                    <thead>
                                      <tr>
                                        <th scope="col ">S.No</th>
                                        <th scope="col">Media_ID</th>
                                        <th scope="col">Media Type</th>

                                        <th scope="col">Created Date</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {posts.map(
                                        (posts.id = (value, index) => (
                                          <tr key={value.id}>
                                            <td>{index + 1}</td>
                                            <td>{value.mediaid}</td>
                                            <td>{value.mediatype}</td>

                                            <td>
                                              {value.create_date
                                                ? value.create_date.slice(0, 10)
                                                : " No Data"}
                                            </td>
                                            <td>
                                              {
                                                <a
                                                  href={`https://gohoardings.com/services/${value.category_name}/${value.meta_title}`}
                                                  target="_blanck"
                                                >
                                                  {value.meta_title}
                                                </a>
                                              }
                                            </td>
                                            {/* <td>{ <a href={`https://gohoardings.com/services/mall-media/facade-dlf-promenade-delhi`} target='_blanck'>{value.meta_title}</a> }</td> */}
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="noDataModal">
                                <span>
                                  <i class="fa-solid fa-triangle-exclamation"></i>
                                  NoData
                                </span>
                              </div>
                            </>
                          )}
                        </td>
                      ) : null}
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
          {/* View of pagination */}

          <Pajination
            setPostPerPage={setPostPerPage}
            postPerpage={postPerpage}
            page={page}
            setPage={setPage}
            total={total}
          />
        </div>
      </div>
    </div>
  );
};

export default Incart;
